// import React from 'react';

// export default function AboutSectionStyle2({ title, subTitle, imgUrl }) {
//   return (
//     <section className="cs_shape_wrap">
//       <div className="cs_shape_1 cs_position_5" />
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-4">
//             <div className="cs_section_heading cs_style_1">
//               <h2 className="cs_section_title cs_fs_72 m-0">{title}</h2>
//               <div className="cs_height_54 cs_height_xl_30" />
//               <p className="m-0">{subTitle}</p>
//               <div className="cs_height_120 cs_height_xl_60" />
//             </div>
//           </div>
//           <div className="col-lg-7 offset-lg-1">
//             <img src={imgUrl} alt={title} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React from "react";

export default function AwardSectionStyle2({
  sectionTitle,
  sectionSubTitle,
  data,
  IconBoxStyle5,
}) {
  return (
    <section className="cs_brand_section">
      <div className="cs_brand_container">
        
        {/* Header */}
        <div className="cs_brand_header">
          <div className="cs_brand_eyebrow">Our Brands</div>

          <h2
            className="cs_brand_title"
            dangerouslySetInnerHTML={{ __html: sectionTitle }}
          />

          <p className="cs_brand_subtitle">{sectionSubTitle}</p>
        </div>

        {/* Grid */}
        <div className="cs_brand_grid">
          {data?.map((item, index) => (
            <IconBoxStyle5 key={index} {...item} />
          ))}
        </div>

        {/* Footer Stats (Optional but looks premium) */}
        <div className="cs_brand_footer">
          <div className="cs_brand_stat">
            <div className="cs_brand_stat_num">
              <span>50+</span>
            </div>
            <div className="cs_brand_stat_label">Products</div>
          </div>

          <div className="cs_brand_stat_divider"></div>

          <div className="cs_brand_stat">
            <div className="cs_brand_stat_num">
              <span>10K+</span>
            </div>
            <div className="cs_brand_stat_label">Doctors Trust</div>
          </div>

          <div className="cs_brand_stat_divider"></div>

          <div className="cs_brand_stat">
            <div className="cs_brand_stat_num">
              <span>100%</span>
            </div>
            <div className="cs_brand_stat_label">Quality Focus</div>
          </div>
        </div>
      </div>
    </section>
  );
}
